import _ from 'lodash';

export default {
	data() {
		return {
			searchResult: [],
			itemChecked: [],
			contentTotal: 0,
			productTitle: null,
			idBrand: null,
			limit: 10,
			pageGroupLimit: 10,
			offset: 0,
		};
	},
	computed: {
		getTotal() {
			return this.contentTotal;
		},
		getCursor() {
			return this.offset;
		},
	},
	methods: {
		paging(args) {
			if (
				this.hasCheckedItem(
					'이미 체크되어 있는 항목 선택을 취소하고 다른 페이지로 이동하시겠습니까?'
				)
			) {
				this.offset = args.offset;
				this.getSearch();
			}
		},
		setBrand(event) {
			this.idBrand = event.idBrand;
		},
		valueOrNull(value) {
			if (typeof value === 'string') {
				return value.trim().length > 0 ? value.trim() : null;
			}

			return value;
		},
		onLimitChange() {
			if (
				this.searchResult.length > 0 &&
				this.hasCheckedItem(
					'이미 체크되어 있는 항목 선택을 취소하고 리스트를 다시 불러오시겠습니까?'
				)
			) {
				this.getSearch(0);
			}
		},
		initCheckedItem() {
			this.itemChecked = [];
			this.$refs.toggleAll.checked = false;
			this.toggleAll(false);
		},
		hasCheckedItem(message) {
			if (this.itemChecked.length > 0) {
				return confirm(message);
			} else {
				return true;
			}
		},
		toggleAll(to) {
			this.itemChecked = [];

			_.each(this.$refs.itemAddToggle, item => {
				item.checked = to;
			});

			if (to) {
				this.itemChecked = this.searchResult;
			}
		},
		itemAddToggle(event, item) {
			if (event.target.checked) {
				this.itemChecked.push(item);
			} else {
				const index = _.findIndex(this.itemChecked, {
					productCode: item.productCode,
				});

				this.itemChecked.splice(index, 1);
			}
		},
		close() {
			this.$store.commit('modal/toggleModal', false);
		},
	},
};
